import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  Rol,
  ReportePermisos,
  TextArea,
  Custom,
  
} from '@app/shared';

@Injectable()
export class GroupsAdministrationForReportsFormsService {
  constructor() { }
  getForm(options: any, template: any, categoria?: any, reporte?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'categoria',
        label: 'Categoria',
        order: 1,
        template: template,
        placeholder: 'Seleccione la categoria',
        value: categoria ? categoria.id ? categoria.id : null : null,
        options: options ? options['categoryReports'] ? options['categoryReports'] : [] : [],
        validations: {
          validators: [Validators.required]
        },
      }),

      new Custom({
        key: 'reporte',
        label: 'Reporte',
        order: 2,
        template: template,
        placeholder: 'Seleccione el reporte',
        value: reporte ? reporte.id ? reporte.id : null : null,
        options: options['reportsOption'],
        condictions: [
          {
            campoDepende: 'categoria',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ],
        validations: {
          validators: [Validators.required]
        },
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/groups-adminisration-for-reports/shared/groups-administration-for-reports.form.service.ts